import './App.css';
import Schedule from './components/Schedule';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/:term" element={<Schedule />} />
          <Route index element={<Schedule />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
